import { RELEASE_TYPES } from './getreleasedetails.js';

const ENDPOINT = 'GETuserLibrary';
var CONTENT_TYPES;
(function (CONTENT_TYPES) {
    CONTENT_TYPES["music"] = "music";
    CONTENT_TYPES["podcast"] = "podcast";
    CONTENT_TYPES["artists"] = "artists";
})(CONTENT_TYPES || (CONTENT_TYPES = {}));
var LIBRARY_TYPE;
(function (LIBRARY_TYPE) {
    LIBRARY_TYPE["live"] = "live";
    LIBRARY_TYPE["draft"] = "draft";
})(LIBRARY_TYPE || (LIBRARY_TYPE = {}));
var LIBRARY_STATUS;
(function (LIBRARY_STATUS) {
    LIBRARY_STATUS["pending_release"] = "pending_release";
    LIBRARY_STATUS["live"] = "live";
    LIBRARY_STATUS["pending_approval"] = "pending_approval";
    LIBRARY_STATUS["draft"] = "draft";
    LIBRARY_STATUS["deleted_draft"] = "deleted_draft";
})(LIBRARY_STATUS || (LIBRARY_STATUS = {}));
var SORTING_FIELD;
(function (SORTING_FIELD) {
    SORTING_FIELD["creation_date"] = "creation_date";
    SORTING_FIELD["release_date"] = "release_date";
    SORTING_FIELD["alphabetically"] = "alphabetically";
})(SORTING_FIELD || (SORTING_FIELD = {}));
var VIDEO_STATUS;
(function (VIDEO_STATUS) {
    VIDEO_STATUS[VIDEO_STATUS["PROCESSING_ERROR"] = -1] = "PROCESSING_ERROR";
    VIDEO_STATUS[VIDEO_STATUS["TAKEN_DOWN"] = 0] = "TAKEN_DOWN";
    VIDEO_STATUS[VIDEO_STATUS["LIVE"] = 1] = "LIVE";
    VIDEO_STATUS[VIDEO_STATUS["PRENDING_APPROVAL"] = 2] = "PRENDING_APPROVAL";
    VIDEO_STATUS[VIDEO_STATUS["PROCESSING"] = 3] = "PROCESSING";
    VIDEO_STATUS[VIDEO_STATUS["REJECTED"] = 4] = "REJECTED";
})(VIDEO_STATUS || (VIDEO_STATUS = {}));
var Release_Item_Keys;
(function (Release_Item_Keys) {
    Release_Item_Keys["cover_art_id"] = "cover_art_id";
    Release_Item_Keys["release_type"] = "release_type";
    Release_Item_Keys["nbr_songs"] = "nbr_songs";
    Release_Item_Keys["added_on"] = "added_on";
    Release_Item_Keys["is_owner"] = "is_owner";
    Release_Item_Keys["artist"] = "artist";
    Release_Item_Keys["release_status"] = "release_status";
    Release_Item_Keys["release_duration"] = "release_duration";
    Release_Item_Keys["has_video"] = "has_video";
    Release_Item_Keys["video"] = "video";
    Release_Item_Keys["duration"] = "duration";
    Release_Item_Keys["audio_url"] = "audio_url";
    Release_Item_Keys["audio_key"] = "audio_key";
    Release_Item_Keys["cover_url"] = "cover_url";
    Release_Item_Keys["cover_key"] = "cover_key";
    Release_Item_Keys["album_type"] = "album_type";
    Release_Item_Keys["genre"] = "genre";
    Release_Item_Keys["category"] = "category";
    Release_Item_Keys["language_id"] = "language_id";
    Release_Item_Keys["songs"] = "songs";
    Release_Item_Keys["description_ar"] = "description_ar";
    Release_Item_Keys["description"] = "description";
    Release_Item_Keys["file_name"] = "file_name";
    Release_Item_Keys["file_size"] = "file_size";
    Release_Item_Keys["album_id"] = "album_id";
    Release_Item_Keys["release_language_id"] = "release_language_id";
    Release_Item_Keys["release_name"] = "release_name";
    Release_Item_Keys["release_name_ar"] = "release_name_ar";
    Release_Item_Keys["upc"] = "upc";
    Release_Item_Keys["release_date"] = "release_date";
    Release_Item_Keys["explicit"] = "explicit";
    Release_Item_Keys["bucket"] = "bucket";
    Release_Item_Keys["stage"] = "stage";
    Release_Item_Keys["artist_id"] = "artist_id";
    Release_Item_Keys["collaborating_artists"] = "collaborating_artists";
    Release_Item_Keys["featuring_artists"] = "featuring_artists";
    Release_Item_Keys["song_id"] = "song_id";
    Release_Item_Keys["isrc"] = "isrc";
    Release_Item_Keys["release_time"] = "release_time";
    Release_Item_Keys["lyrics"] = "lyrics";
    Release_Item_Keys["artist_name"] = "artist_name";
    Release_Item_Keys["artist_name_ar"] = "artist_name_ar";
    Release_Item_Keys["owner"] = "owner";
    Release_Item_Keys["show_id"] = "show_id";
    Release_Item_Keys["is_podcast"] = "is_podcast";
    Release_Item_Keys["actions"] = "actions";
    Release_Item_Keys["video_id"] = "id";
    Release_Item_Keys["video_thumbnail_id"] = "thumbnail_id";
    Release_Item_Keys["video_status"] = "status";
    Release_Item_Keys["video_location"] = "url";
    Release_Item_Keys["video_release_date"] = "release_date";
    Release_Item_Keys["artist_plays"] = "artist_plays";
})(Release_Item_Keys || (Release_Item_Keys = {}));
function getUserLibrary(gateway, params = {
    content_type: CONTENT_TYPES.music,
    release_type: RELEASE_TYPES.ALL,
    library_type: LIBRARY_TYPE.live
}) {
    return gateway.get(getUserLibrary.endpoint, params);
}
getUserLibrary.endpoint = ENDPOINT;

export { CONTENT_TYPES, LIBRARY_STATUS, LIBRARY_TYPE, Release_Item_Keys, SORTING_FIELD, VIDEO_STATUS, getUserLibrary as default };
//# sourceMappingURL=getUserLibrary.js.map
